import { ILocation } from "./components/CustomInput/Inputypes/Location/locationHelpers";

export type DataKeep = {
    inputValues: {},
    titleValue: string,
    businessIdValue: string,
    attachments: [],
    dataTypes: {},
    location: ILocation | null,
}
class ManagerKeep {
    private loaded = false;
    private lastKey = "";
    init = (uid: string, dataType: string) => {
        const key = `keep:${uid}:${dataType}`;
        this.lastKey = key;
        const value = localStorage.getItem(key);
        if(!value) {
            this.loaded = true;
            return null;
        }
        try {
            const _data = JSON.parse(value);
            if('inputValues' in _data) {
                this.loaded = true;
                return _data as DataKeep;
            }
            this.loaded = true;
            return null;
        } catch (error) {
            this.loaded = true;
            return null;   
        }
    }

    remove = (uid: string, dataType: string) => {
        const key = `keep:${uid}:${dataType}`;
        localStorage.removeItem(key);
        this.loaded = false;
    }

    removeLastKey = () => {
        if(!this.lastKey) return;
        localStorage.removeItem(this.lastKey);
        this.loaded = false;
    }

    prepareData = (data: DataKeep) => {
        const vals = {...data.inputValues}
        Object.keys(vals).forEach(key => {
            //@ts-ignore
            const val = vals?.[key]
            if(!!val && val?.includes?.('signature-image-temp.png')) {
                //@ts-ignore
                vals[key] = undefined;
            }
        });

        return {
            ...data,
            inputValues: vals,
            attachments: data.attachments,
        }
    }
    save = (uid: string, dataType: string, data: DataKeep) => {
        if(!this.loaded) return;
        const key = `keep:${uid}:${dataType}`;
        this.lastKey = key;
        const preparedData = this.prepareData(data);
        localStorage.setItem(key, JSON.stringify(preparedData));
    }
}

export const managerKeep = new ManagerKeep();